<template>
  <el-card>
    <template #header>
      <content-header />
    </template>

    <el-button-group class="mb-3"><search-form :fields="search" />
      <el-popconfirm
        confirm-button-text="确定"
        cancel-button-text="取消"
        icon="el-icon-info"
        icon-color="red"
        title="确认离线导出么？"
        @confirm="rsyncExport"
      >
        <el-button slot="reference"><i class="el-icon-upload2"></i>离线导出</el-button>
      </el-popconfirm>
      <button-link :to="`downloads`"><i class="el-icon-download"></i>下载中心</button-link>
    </el-button-group>

    <el-table :data="saleGoodsMonthlyStats" resource="sale-goods-monthly-stats" v-loading="loading">
      <el-table-column prop="id" label="ID" width="100" />
      <el-table-column align="center" header-align="center" label="账号" width="120">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            <span>{{ scope.row.user.real_name }}({{ scope.row.user.level_name }})</span>
            <br />
            <span>{{ scope.row.user.mobile }}</span>
            <br />
            <span>{{ scope.row.user.idcard_no }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="month_tag" label="盛塘期" width="120">
        <template slot-scope="scope">
          <span>第{{ scope.row.month_tag-1 }}期</span>
        </template>
      </el-table-column>
      <el-table-column label="TA自己">
        <template slot-scope="scope">
          报单：
          <span class="color-warning">{{ scope.row.self_debit_num }} 件({{ scope.row.self_debit_amount }} 元)</span>
          <br />
          复销：
          <span class="color-info">{{ scope.row.self_repeat_num }} 件({{ scope.row.self_repeat_amount }} 元)</span>
        </template>
      </el-table-column>

      <el-table-column label="团队报单数(推荐)">
        <template slot-scope="scope">
          <span class="color-warning">{{ scope.row.team_invite_debit_num }} 件({{ scope.row.team_invite_debit_amount }} 元)</span>
        </template>
      </el-table-column>

      <el-table-column label="团队复销数(推荐)">
        <template slot-scope="scope">
          <span class="color-warning">{{ scope.row.team_invite_repeat_num }} 件({{ scope.row.team_invite_repeat_amount }} 元)</span>
        </template>
      </el-table-column>

      <el-table-column label="团队报单数(安置)">
        <template slot-scope="scope">
          <span class="color-warning">{{ scope.row.team_posit_debit_num }} 件({{ scope.row.team_posit_debit_amount }} 元)</span>
        </template>
      </el-table-column>

      <el-table-column label="团队复销数(安置)">
        <template slot-scope="scope">
          <span class="color-warning">{{ scope.row.team_posit_repeat_num }} 件({{ scope.row.team_posit_repeat_amount }} 元)</span>
        </template>
      </el-table-column>

      <el-table-column label="操作" width="200">
        <template slot-scope="scope">
          <el-button-group>
            <el-button @click="showByLeader(scope.row, 0)" size="small">查看TA的【推荐】团队业绩</el-button>
            <el-button @click="showByLeader(scope.row, 1)" size="small">查看TA的【安置】团队业绩</el-button>
          </el-button-group>
        </template>
      </el-table-column>
    </el-table>
    <div class="card-footer"><pagination :page="page" /></div>

    <el-dialog :title="dialogLeadertitle" :visible.sync="dialogLeaderMonthlyVisible" width="1200px" append-to-body v-loading="loading">
      <el-select v-model="userGoodsSaleQueryData.month_tag" placeholder="===所有===" style="width:350px" clearable>
        <el-option v-for="item in userGoodsSaleMonthlyIssueList" :key="item.value" :label="item.label" :value="item.value"></el-option>
      </el-select>

      &nbsp;
      <el-button type="primary" @click="queryList">查询</el-button>
      <el-button type="primary" @click="queryAllList">查询所有</el-button>
      <el-divider></el-divider>
      <el-table :data="userGoodsSaleMonthlyList" v-loading="loading">
        <el-table-column type="index" property="id" label="序号" width="50" />
        <el-table-column align="center" header-align="center" label="会员" width="150">
          <template slot-scope="scope">
            <div v-if="scope.row.user">
              <span>{{ scope.row.user.real_name }}({{ scope.row.user.level_name }})</span>
              <br />
              <span>{{ scope.row.user.mobile }}</span>
              <br />
              <span>{{ scope.row.user.idcard_no }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="month_tag" label="盛塘期" width="120">
          <template slot-scope="scope">
            <span>第{{ scope.row.month_tag-1 }}期</span>
          </template>
        </el-table-column>
        <el-table-column label="TA自己">
          <template slot-scope="scope">
            报单：
            <span class="color-warning">{{ scope.row.self_debit_num }} 件({{ scope.row.self_debit_amount }} 元)</span>
            <br />
            复销：
            <span class="color-info">{{ scope.row.self_repeat_num }} 件({{ scope.row.self_repeat_amount }} 元)</span>
          </template>
        </el-table-column>
        <template v-if="dimension === 0">
          <el-table-column label="团队报单数(推荐)">
            <template slot-scope="scope">
              <span class="color-warning">{{ scope.row.team_invite_debit_num }} 件({{ scope.row.team_invite_debit_amount }} 元)</span>
            </template>
          </el-table-column>

          <el-table-column label="团队复销数(推荐)">
            <template slot-scope="scope">
              <span class="color-warning">{{ scope.row.team_invite_repeat_num }} 件({{ scope.row.team_invite_repeat_amount }} 元)</span>
            </template>
          </el-table-column>
        </template>
        <template v-else>
          <el-table-column label="团队报单数(安置)">
            <template slot-scope="scope">
              <span class="color-warning">{{ scope.row.team_posit_debit_num }} 件({{ scope.row.team_posit_debit_amount }} 元)</span>
            </template>
          </el-table-column>

          <el-table-column label="团队复销数(安置)">
            <template slot-scope="scope">
              <span class="color-warning">{{ scope.row.team_posit_repeat_num }} 件({{ scope.row.team_posit_repeat_amount }} 元)</span>
            </template>
          </el-table-column>
        </template>
      </el-table>
      <div>
        <el-divider></el-divider>
        <el-pagination
          background
          @current-change="userGoodsSaleMonthlyPageChange"
          :current-page.sync="userGoodsSaleQueryData.current_page"
          :page-size="userGoodsSaleQueryData.per_page"
          layout="total, prev, pager, next,jumper"
          :total="userGoodsSaleQueryData.total"
        />
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import SearchForm from '@c/SearchForm';
import Pagination from '@c/Pagination';
import { getSaleGoodsMonthlyStats,exportSaleGoodsMonthlyStats } from '@/api/sale-goods-monthly-stats';
import ButtonLink from '@c/ButtonLink'

export default {
  name: 'Index',
  components: {
    SearchForm,
    Pagination,
    ButtonLink
  },
  data() {
    return {
      search: [
        {
          field: 'keyword',
          label: '手机号码/姓名',
        },
        {
          field: 'month_tag',
          label: '盛塘期',
          type: 'el-select',
          options: [],
          labelField: 'label', // 默认为 name
          valueField: 'value', // 默认为 id
        },
      ],
      saleGoodsMonthlyStats: [],
      page: null,
      // monthlyList: [],
      dimension: 0, // 推荐关系->0,安置关系->1;
      loading: true,
      dialogLeaderMonthlyVisible: false,
      dialogLeadertitle: '',
      userGoodsSaleMonthlyList: [],
      userGoodsSaleMonthlyIssueList: [],
      userGoodsSaleMonthlyPage: {},
      userGoodsSaleQueryData: {
        parent_id: 0,
        posit_parent_id: 0,
        page_size: 8,
        month_tag: ''
      },
      query: {},
    };
  },
  methods: {
    async rsyncExport() {
      try {
        await exportSaleGoodsMonthlyStats(this.query);
        this.$message.success('离线下载中...');
      } catch (e) {
        const res = e.response
        const err = getFirstError(res)
        err && this.$message.error(err)
      }
    },
    showByLeader(row, type) {
      this.dialogLeadertitle = '【' + row.user.username + '(' + row.user.real_name + ')' + '】商品销售月统计【' + (type === 0 ? '推荐' : '安置') + '】团队业绩';
      this.dimension = type;
      this.dialogLeaderMonthlyVisible = true;
      this.userGoodsSaleQueryData = {
        parent_id: this.dimension === 0 ? row.user_id : 0,
        posit_parent_id: this.dimension === 0 ? 0 : row.user_id,
        page_size: 8,
        month_tag: row.month_tag
      };
      this.getUserGoodsSaleMonthlyList();
    },
    async queryList() {
      this.getUserGoodsSaleMonthlyList();
    },
    async queryAllList() {
      this.userGoodsSaleQueryData.month_tag = "";
      this.getUserGoodsSaleMonthlyList();
    },
    async getUserGoodsSaleMonthlyList() {
      this.loading = true;
      const {
        data: { data, meta, monthlyList }
      } = await getSaleGoodsMonthlyStats(this.userGoodsSaleQueryData);
      this.userGoodsSaleMonthlyList = data;
      this.userGoodsSaleMonthlyPage = meta;
      this.userGoodsSaleMonthlyIssueList = monthlyList;
      this.loading = false;
    },
    userGoodsSaleMonthlyPageChange(val) {
      this.userGoodsSaleQueryData.page = val;
      this.getUserGoodsSaleMonthlyList();
    }
  },
  watch: {
    $route: {
      async handler(newVal) {
        this.query = newVal.query;
        const {
          data: { data, meta, monthlyList }
        } = await getSaleGoodsMonthlyStats(newVal.query);
        this.saleGoodsMonthlyStats = data;
        this.page = meta;
        this.search[1].options = monthlyList;
        this.loading = false;
        // this.monthlyList = monthlyList;
      },
      immediate: true
    }
  }
};
</script>
